import SharedContactsGrid from '../directory/shared-contacts/shared-contacts-grid';

import Box from '@mui/material/Box';
import SharedTabHeader from '../../shared/shared-tab-header';

export default function SharedContactsUserPortalPage() {
  return (
    <Box
      sx={{
        p: 2,
        pt: 1,
      }}
    >
      <SharedTabHeader title="Shared Contacts" noDivider />
      <Box
        sx={{ minHeight: 300, height: '62vh', width: '95%', mx: 'auto', mt: 1 }}
      >
        <SharedContactsGrid userView={true} />
      </Box>
    </Box>
  );
}
